import { iterable, mix, observable } from "@chorda/core";
export const Table = (props) => {
    return mix({
        tag: 'table',
        css: 'table',
        templates: {
            colgroup: {
                tag: 'colgroup',
                weight: -10,
                defaultItem: {
                    tag: 'col'
                }
            },
            header: {
                tag: 'thead',
                defaultItem: {
                    tag: 'tr',
                    defaultItem: {
                        tag: 'th'
                    }
                }
                // defaultItem: Row({
                //     defaultCell: HeaderCell({})
                // }),
                // bindings: {
                //     hrows: (v: any, s: any) => {
                //         console.log('rows', v)
                //         ({items: v})
                //     }
                // }
            },
            body: {
                tag: 'tbody',
                defaultItem: {
                    tag: 'tr',
                    defaultItem: {
                        tag: 'td'
                    }
                },
                reactions: {
                    rows: (next) => ({ items: next })
                },
                injections: {
                    rows: $ => iterable($.data, 'data')
                }
            }
        }
    }, {
        components: {
            colgroup: {
                items: props.cols
            },
            header: {
                items: props.headerRows
            },
            body: {
                items: props.rows,
                defaultItem: props.defaultRow,
            }
        },
        injections: {
            data: props.data$ || (() => observable(props.data))
        }
    });
};
export const Col = (props) => {
    return {
        //        tag: 'col',
        dom: {
            width: props.width // || '150px'
        }
    };
};
export const Row = (props) => {
    return mix({}, {
        defaultItem: props.defaultCell,
        items: props.cells,
        // injections: {
        //     data: props.data$ || (() => props.data)
        // },
        // reactions: {
        //     data: (v) => ({items: v})
        // }
    });
};
export const Cell = (props) => {
    return mix(/*{
//        tag: 'td'
    }, */ props && {
        //        text: props.text,
        reactions: {
            data: (v) => ({ text: (props.format || String)(v) }) //({text: (props.format || String)(v)})
        },
        injections: {
            data: props.data$ || (() => props.text)
        }
    });
};
